import { builderCopy as copy } from "./copy";
import type { StartChoice } from "./stages";

/**
 * My Dials with no dials on it, for someone who can build one (KEY-560): the three ways to begin, each opening the builder with
 * that start already chosen.
 */
export function BuildFirstDial({ onStart }: { onStart: (start: StartChoice) => void }) {
  return (
    <section className="kd-card kd-first-dial" aria-labelledby="kd-first-dial-heading">
      <h2 id="kd-first-dial-heading" className="kd-first-dial-heading">
        {copy.waysIn.emptyHeading}
      </h2>
      <p className="kd-first-dial-line">{copy.waysIn.emptyLine}</p>
      <div className="kd-launch-actions">
        <button type="button" className="kd-btn-primary" onClick={() => onStart("describe")}>
          {copy.waysIn.describeIt}
        </button>
        <button type="button" className="kd-btn" onClick={() => onStart("template")}>
          {copy.waysIn.useTemplate}
        </button>
        <button type="button" className="kd-btn" onClick={() => onStart("blank")}>
          {copy.waysIn.startBlank}
        </button>
      </div>
    </section>
  );
}
